import clsx from "clsx"
import Image from "next/image"
import Link from "next/link"
import React from "react"

interface InvestmentsProp {
  className?: string
  companyLogo?: {
    url: string
  }
  company?: string
  url?: string
  description?: string
}

const InvestmentCard: React.FC<InvestmentsProp> = ({
  className,
  companyLogo,
  company,
  url,
  description,
}) => (
  <div
    className={clsx(
      "duration-200 ease-in-out hover:-translate-y-2 hover:opacity-80 my-8 col-span-4",
      className,
    )}
  >
    {/* Conditionally wrap content in a Link if URL exists */}
    {url ? (
      <Link href={url} target="_blank">
        <div className="max-w-full h-[200px] rounded-lg bg-gray-85 flex justify-center items-center overflow-hidden relative cursor-pointer">
          <div className="relative w-full h-full max-w-[300px] max-h-[100px]">
            <Image
              className="object-center object-contain"
              alt={company}
              src={companyLogo?.url ?? "/default-image.png"}
              fill
            />
          </div>
        </div>

        <div className="flex flex-col h-40 p-4 mt-4 lg:h-48 text-white-100">
          <h5 className="pb-5 heading2">{company}</h5>
          <p className="mb-auto body3">{description}</p>
        </div>
      </Link>
    ) : (
      <>
        <div className="max-w-full h-[200px] rounded-lg bg-gray-85 flex justify-center items-center overflow-hidden relative">
          <div className="relative w-full h-full max-w-[300px] max-h-[100px]">
            <Image
              className="object-center object-contain"
              alt={company}
              src={companyLogo?.url ?? "/default-image.png"}
              fill
            />
          </div>
        </div>

        <div className="flex flex-col h-40 p-4 mt-4 lg:h-48 text-white-100">
          <h5 className="pb-5 heading2">{company}</h5>
          <p className="mb-auto body3">{description}</p>
        </div>
      </>
    )}
  </div>
)

export default InvestmentCard
